module.exports = __webpack_public_path__ + "img/engagementring.ccb0d5e.webp";